"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.slugField = slugField;
exports.slugEnField = slugEnField;
const zod_1 = require("zod");
const SLUG_RE = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
// Zorunlu TR slug alanı: URL'de kullanılır, yalnızca küçük harf/rakam/tire.
function slugField(max) {
    return zod_1.z
        .string()
        .min(1, "Slug zorunludur")
        .max(max)
        .regex(SLUG_RE, "Slug yalnızca küçük harf, rakam ve tire içerebilir");
}
// Opsiyonel EN slug alanı: boş string null'a çevrilir (unique index'te "" çakışmasın).
function slugEnField(max) {
    return zod_1.z.preprocess((v) => (typeof v === "string" && v.trim() === "" ? null : v), zod_1.z
        .string()
        .max(max)
        .regex(SLUG_RE, "EN slug yalnızca küçük harf, rakam ve tire içerebilir")
        .nullable()
        .optional());
}
//# sourceMappingURL=slug-field.js.map